import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { InvoicesTableDataSource } from './invoices.table.data';
import { Invoice } from './invoice';
import { AmplitudeService } from 'app/shared/services/amplitude.service';

@Component({
  selector: 'cc-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  public displayedColumns = ['createdAt', 'amount', 'url'];
  public matDataSource: MatTableDataSource<Invoice>;

  @ViewChild(MatSort) sort: MatSort;

  constructor(public dataSource: InvoicesTableDataSource, private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.dataSource.onConnect().subscribe(([data]) => {
      this.matDataSource = new MatTableDataSource(data);

      this.matDataSource.sortingDataAccessor = (tableData: any, sortHeaderId: string): string => {
        if (typeof tableData[sortHeaderId] === 'string') {
          return tableData[sortHeaderId].toLocaleLowerCase();
        }
        return tableData[sortHeaderId];
      };

      this.matDataSource.sort = this.sort;
    });
  }

  downloadClicked() {
    this.amplitudeService.logEvent('Panel:Billing:Invoice: Download');
  }
}
